export default __webpack_public_path__ + "static/media/amir-dadon_kol-yom-kmo-nes.2c12c2c1.mp3";